module.exports = __webpack_public_path__ + "img/3538b33.png";